module.exports = __webpack_public_path__ + "static/media/CBN.3a0d18ce.gif";